export default "__VITE_ASSET__CEODO3SR__"